import { PoolName } from "@/shared/constants/pools";
import { ChainName } from "@/shared/types/networks";

import { ArbitrumActivePools } from "../../constants/active-pools";
import { getUniswapPoolParams } from "../../utils/get-uniswap-pool-params";

const deltaByPoolNameArbitrum: Record<ArbitrumActivePools, number> = {
  [PoolName.ArbUsdc]: 0.15,
  [PoolName.WethUsdc]: 0.0001,
  [PoolName.WbtcWeth]: 0.01,
  [PoolName.ArbUsdce]: 0.15,
  [PoolName.WethUsdce]: 0.0001,
};

const poolsDeltasByChainName: Record<
  ChainName,
  Partial<Record<PoolName, number>>
> = {
  [ChainName.Arbitrum]: deltaByPoolNameArbitrum,
  [ChainName.ArbitrumGoerli]: {},
  [ChainName.PolygonMumbai]: {},
};

export const getFetchParams = (poolName: PoolName, chainName: ChainName) => {
  const poolParams = getUniswapPoolParams(poolName, chainName);
  const delta = poolsDeltasByChainName[chainName][poolName];
  if (!poolParams || !delta) return;

  return { ...poolParams, priceDelta: delta };
};
